var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.071,
    height: 10.071,
    x: 0.6,
    y: 3.945,
    stroke: "currentColor",
    strokeWidth: 1.2,
    rx: 1.778
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M3.266 1.945s0-1.11 2.07-1.11l5.05-.001c1.097 0 1.644 0 2.054.234.276.157.505.386.663.663.234.41.234.957.234 2.053V8.39c0 2.516-.89 2.516-.89 2.516"
  })));
};
export default SvgCopy;